<template>
    <div>
        <!-- ======= Contact Section ======= -->
        <section id="contact" class="contact mt-5">
            <div class="container">

                <div class="section-title">
                    <h2><span>Contact</span> Us</h2>
                    <p>Ut possimus qui ut temporibus culpa velit eveniet modi omnis est adipisci expedita at voluptas
                        atque
                        vitae
                        autem.</p>
                </div>
            </div>

            <div class="map">
                <iframe style="border:0; width: 100%; height: 350px;"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12097.433213460943!2d-74.0062269!3d40.7101282!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb89d1fe6bc499443!2sDowntown+Conference+Center!5e0!3m2!1smk!2sbg!4v1539943755621"
                    frameborder="0" allowfullscreen></iframe>
            </div>

            <div class="container mt-5">

                <div class="info-wrap">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 info">
                            <i class="fa-solid fa-map-location" style="color: #3c3b16;"></i>
                            <h4>Location:</h4>
                            <p>A108 Adam Street<br>New York, NY 535022</p>
                        </div>

                        <div class="col-lg-3 col-md-6 info mt-4 mt-lg-0">
                            <i class="fa-regular fa-clock" style="color: #3c3b16;"></i>
                            <h4>Open Hours:</h4>
                            <p>Monday-Saturday:<br>11:00 AM - 2300 PM</p>
                        </div>

                        <div class="col-lg-3 col-md-6 info mt-4 mt-lg-0">
                            <i class="fa-solid fa-envelope" style="color: #3c3b16;"></i>
                            <h4>Email:</h4>
                            <p>info@example.com<br>contact@example.com</p>
                        </div>

                        <div class="col-lg-3 col-md-6 info mt-4 mt-lg-0">
                            <i class="fa-solid fa-phone-flip" style="color: #3c3b16;"></i>
                            <h4>Call:</h4>
                            <p>+1 5589 55488 51<br>+1 5589 22475 14</p>
                        </div>
                    </div>
                </div>

                <form @submit.prevent="submit" role="form" class="php-email-form" v-if="form">
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control" v-model="form.name" placeholder="Your Name" disabled>
                        </div>
                        <div class="col-md-6 form-group mt-3 mt-md-0">
                            <input type="email" class="form-control" v-model="form.email" placeholder="Your Email" disabled>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <input type="text" class="form-control" v-model="form.subject" placeholder="Subject" required>
                    </div>
                    <div class="form-group mt-3">
                        <textarea class="form-control" v-model="form.message" rows="5" placeholder="Message"
                            required></textarea>
                    </div>
                    <div class="my-3">
                        <div class="loading">Loading</div>
                        <div class="error-message"></div>
                        <div class="sent-message">Your message has been sent. Thank you!</div>
                    </div>
                    <div class="text-center"><button type="submit">Send Message</button></div>
                </form>

            </div>
        </section><!-- End Contact Section -->
    </div>
</template>


<script>

import { mapGetters } from 'vuex'

export default {
    name: 'user-suggestion',

    data() {
        return {
            form: {
                user_id: '',
                name: '',
                email: '',
                subject: '',
                message: '',
                rating: 1

            }
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'auth/getUserData'
        })
    },

    methods: {
        submit() {
            this.$store.dispatch('users/submitReview', this.form)
        },


        setData() {
            this.form.name = this.userInfo.name
            this.form.email = this.userInfo.email
            this.form.user_id = this.userInfo.id
        }
    },

    watch: {
        userInfo() {
            this.setData()
        }
    },

    mounted() {
        if (this.userInfo) {
            this.setData()
        }
    },

}
</script>

<style  scoped></style>
